var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 17.814,
    viewBox: "0 0 27 17.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(-1061 -313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_647",
    "data-name": "Path 647",
    transform: "translate(1061 313)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H25a2.123,2.123,0,0,1,2,2.227v13.36a2.123,2.123,0,0,1-2,2.227H2a2.123,2.123,0,0,1-2-2.227V2.227A2.123,2.123,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2 1 C 1.448600769042969 1 1 1.550300598144531 1 2.226710319519043 L 1 15.58699989318848 C 1 16.26342010498047 1.448600769042969 16.813720703125 2 16.813720703125 L 25 16.813720703125 C 25.55139923095703 16.813720703125 26 16.26342010498047 26 15.58699989318848 L 26 2.226710319519043 C 26 1.550300598144531 25.55139923095703 1 25 1 L 2 1 M 2 0 L 25 0 C 26.10457038879395 0 27 0.9969310760498047 27 2.226710319519043 L 27 15.58699989318848 C 27 16.8167896270752 26.10457038879395 17.813720703125 25 17.813720703125 L 2 17.813720703125 C 0.8954296112060547 17.813720703125 0 16.8167896270752 0 15.58699989318848 L 0 2.226710319519043 C 0 0.9969310760498047 0.8954296112060547 0 2 0 Z",
    stroke: "none",
    fill: "#102250"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x2: 8.997,
    transform: "translate(1069.5 325.5)",
    fill: "none",
    stroke: "#102250",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x2: 26,
    transform: "translate(1061.5 316.5)",
    fill: "none",
    stroke: "#102250",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 7,
    transform: "translate(1069.5 327.5)",
    fill: "none",
    stroke: "#102250",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    y2: 13,
    transform: "translate(1066.5 316.5)",
    fill: "none",
    stroke: "#102250",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x2: 21,
    transform: "translate(1066.5 322.5)",
    fill: "none",
    stroke: "#102250",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.8d0795e980b32a9b6573acb798d679f4.svg";
export { ForwardRef as ReactComponent };